import { FamilyRelationshipT } from '@segurodeceso/core/domain/lead';

export const familyRelationships: FamilyRelationshipT[] = [
  {
    value: '16',
    label: 'Hija o hijo del (la) conviviente civil',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 70 },
      minAge: { day: 14, year: 0 },
    },
  },
  {
    value: '18',
    label: 'Hija o hijo de tu cónyuge',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 70 },
      minAge: { day: 14, year: 0 },
    },
  },
  {
    value: '15',
    label: 'Conviviente civil (con AUC)',
    isSelectedMultiple: false,
    notCombinedWithIds: ['2', '18'],
    restrictions: {
      maxAge: { day: -1, year: 70 },
      minAge: { day: 0, year: 18 },
    },
  },
  {
    value: '2',
    label: 'Cónyuge',
    isSelectedMultiple: false,
    notCombinedWithIds: ['16', '15'],
    restrictions: {
      maxAge: { day: -1, year: 70 },
      minAge: { day: 0, year: 18 },
    },
  },
  {
    value: '8',
    label: 'Madre',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 75 },
      minAge: { day: 0, year: 18 },
    },
  },
  {
    value: '7',
    label: 'Padre',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 75 },
      minAge: { day: 0, year: 18 },
    },
  },
  {
    value: '3',
    label: 'Hija o hijo',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 70 },
      minAge: { day: 14, year: 0 },
    },
  },
  {
    value: '19',
    label: 'Padre del cónyuge o conviviente civil',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 75 },
      minAge: { day: 0, year: 18 },
    },
  },
  {
    value: '20',
    label: 'Madre del cónyuge o conviviente civil',
    isSelectedMultiple: true,
    notCombinedWithIds: [],
    restrictions: {
      maxAge: { day: -1, year: 75 },
      minAge: { day: 0, year: 18 },
    },
  },
];

export const filterAvailableRelations = (
  allOptions: FamilyRelationshipT[],
  selectedValues: string[],
  index: number
): FamilyRelationshipT[] => {
  const currentValues = selectedValues.filter((_, i) => i !== index);

  const notCombinedWithIds = currentValues.flatMap((value) => {
    const option = allOptions.find((option) => option.value === value);
    return option ? option.notCombinedWithIds : [];
  });

  return allOptions.filter(({ value }) => {
    const familiarOption = allOptions.find((option) => option.value === value);

    // 1. Only one if isSelectedMultiple is false
    if (currentValues.includes(value) && !familiarOption.isSelectedMultiple) {
      return false;
    }

    // 2. Filter ids included in notCombinedWithIds selected
    if (notCombinedWithIds.includes(value)) {
      return false;
    }

    return true;
  });
};
